import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FranchiseGroup from "./FranchiseGroup";

// The filtered list of franchise groups. Purely presentational -- all filtering happens in
// franchiseAdminModel.filterFleet before the list ever sees the data.
export default function FranchiseGroupList(props) {
  const franchises = props.franchises || [];
  const showActions = props.showActions;
  const hasFilters = props.hasFilters;
  const bdmOptions = props.bdmOptions;
  const onSaveOwnership = props.onSaveOwnership;
  const onSaveDetails = props.onSaveDetails;
  const onSaveSite = props.onSaveSite;
  const onDeleteSite = props.onDeleteSite;
  const onSaveFranchiseDetails = props.onSaveFranchiseDetails;
  const onSaveFranchiseOwnership = props.onSaveFranchiseOwnership;
  const onSaved = props.onSaved;

  if (franchises.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          {hasFilters
            ? "No franchises or facilities match the current filters."
            : "No franchises to display."}
        </Typography>
      </Box>
    );
  }

  const groups = franchises.map((franchise) => (
    <FranchiseGroup
      key={franchise.comcode}
      franchise={franchise}
      showActions={showActions}
      bdmOptions={bdmOptions}
      onSaveOwnership={onSaveOwnership}
      onSaveDetails={onSaveDetails}
      onSaveSite={onSaveSite}
      onDeleteSite={onDeleteSite}
      onSaveFranchiseDetails={onSaveFranchiseDetails}
      onSaveFranchiseOwnership={onSaveFranchiseOwnership}
      onSaved={onSaved}
    />
  ));

  return <Box>{groups}</Box>;
}
